var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 68,
    viewBox: "0 0 92 68",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h92v68h-92z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-170.233 67.938 10.176-10.162a2.777 2.777 0 0 1 1.748-.615 2.731 2.731 0 0 1 2.732 2.732 2.726 2.726 0 0 1 -.806 1.926l-3.961 3.961-6.023 6.023",
    transform: "translate(194.436 -37.502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-173.053 65.966 9.274-9.288 3.852-3.852a2.679 2.679 0 0 1 1.94-.806 2.74 2.74 0 0 1 2.732 2.732 2.727 2.727 0 0 1 -.806 1.926l-2.964 2.978-10.175 10.162",
    transform: "translate(193.405 -40.021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-167.738 66.744 9.792-9.805a2.851 2.851 0 0 0 .8-2.613 2.884 2.884 0 0 0 -2.25-2.249 2.857 2.857 0 0 0 -2.613.8l-13.461 13.459a1.445 1.445 0 0 1 -1.646.28 1.44 1.44 0 0 1 -.809-1.458l.5-4.48a4.287 4.287 0 0 0 -.923-3.172 4.362 4.362 0 0 0 -2.9-1.6l-1.442-.159s-1.807 17.743-2.251 21.668.226 8.038 3.222 11.032a11.98 11.98 0 0 0 14.219 2.027 13.547 13.547 0 0 0 3.107-2.423l15.045-15.266a2.891 2.891 0 0 0 .707-2.942 2.876 2.876 0 0 0 -2.352-1.947 2.8 2.8 0 0 0 -2.234.634 1.189 1.189 0 0 0 -.2.187l-6.159 6.172",
    transform: "translate(187.07 -40.021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-167.053 86.135a13.652 13.652 0 0 0 13.653-13.652",
    transform: "translate(195.6 -30.427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-165.711 80.65a6.825 6.825 0 0 0 6.825-6.825",
    transform: "translate(196.091 -29.936)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.c7de30554f9294c6e3ff63fb4c260634.svg";
export { ForwardRef as ReactComponent };